import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import styles from './Tooltip.scss';
import classNames from 'classnames';
import { t } from '~/helpers/localization';
import TooltipFooter from '@wg/wows-react-uikit/TooltipFooter';
import Message from '@wg/wows-react-uikit/Message';
import { CREWS_CATEGORY, VEHICLE_CATEGORY } from '~/Actions/ActionCategory';
import { State } from '~/Reducers';

type IProps = {
    background?: string;
    waterIcon?: boolean;
    icon: string | React.ReactElement;
    titleIcon?: string;
    title: string | React.ReactChild;
    preTitle?: React.ReactChild;
    description: string;
    isExclusive?: boolean;
    isEnabled: boolean;
    isIconContain: boolean;
    isBigTooltip?: boolean;
    isMoreInfo?: boolean;
    debugInfo?: string;
    isUniqueItem?: boolean;
    isRareItem?: boolean;
    category: string;
    content?: React.ReactChild;
    isGold?: boolean;
    type?: string;
};

interface IState {
    isAuthorizedUser: boolean;
}

const stateSelector = (state: State): IState => {
    return {
        isAuthorizedUser: state.ReducerApp.isAuthorizedUser,
    };
};

const Tooltip = (props: IProps) => {
    const appState = useSelector<State, IState>(stateSelector, shallowEqual);

    const renderAdditionalInfo = () => {
        if (!props.isMoreInfo) {
            return null;
        }

        return (
            <div className={classNames(styles.footerText, styles.lineHeight25, styles.top)}>
                <TooltipFooter mouseIcon={'left'}>{t('Подробнее')}</TooltipFooter>
            </div>
        );
    };

    const styleBackground = { backgroundImage: `url(${props.background})` };
    const styleTitleIcon = { backgroundImage: `url(${props.titleIcon})` };

    const classNameIcon = classNames(styles.icon, {
        [styles.iconContain]: props.isIconContain,
    });

    const classNameInfo = classNames(styles.tooltipInfo, {
        [styles.gold]: props.isGold,
        [styles.tooltipBigInfo]: props.isBigTooltip,
        [styles.uppercase]: props.category === VEHICLE_CATEGORY,
    });

    const classNameCategory = classNames(styles.tooltipCategory, {
        [styles.gold]: props.isGold,
        [styles.tooltipBigCategory]: props.isBigTooltip,
    });

    const classNameIconType = classNames(styles.iconType, styles.tooltipIconType);

    const classNameFooter = classNames(styles.footerText, styles.top, styles.lineHeight25, {
        [styles.notEnabled]: !props.isEnabled,
    });

    const classNameTooltipHeader = classNames(styles.tooltipHeader, {
        [styles.tooltipHeaderColumn]: props.isBigTooltip,
    });

    const classNameTooltipIcon = classNames(styles.tooltipIcon, {
        [styles.bigIcon]: props.isBigTooltip,
        [styles.size130]: props.category === VEHICLE_CATEGORY || props.category === CREWS_CATEGORY,
    });

    const classNameWater = classNames(styles.tooltipIconWater, {
        [styles.tooltipBigIconWater]: props.isBigTooltip,
    });

    const typeMessage = props.isEnabled ? 'done' : 'error';

    const rareItemText = t('Категория: Редкие');
    const specialItemText = t('Категория: Дополнительные');

    const tooltipContentClassName = classNames(styles.tooltip, {
        [styles.tooltipRare]: props.isRareItem,
    });

    const classesSpecialMark = classNames(styles.itemTypeMark, styles[props.category], styles[props.type]);

    return (
        <div id={'TooltipContent'} className={tooltipContentClassName}>
            <div className={styles.body}>
                <div className={classNameTooltipHeader}>
                    <div className={classNameTooltipIcon}>
                        {props.waterIcon && <div className={classNameWater} />}
                        {props.background && <div className={styles.background} style={styleBackground} />}
                        {typeof props.icon === 'string' ? <div className={classNameIcon} style={{ backgroundImage: `url(${props.icon})` }} /> : props.icon}
                        {props.type && <div className={classesSpecialMark} />}
                    </div>
                    <div className={styles.tooltipInfoWrap}>
                        <div className={classNameInfo}>
                            {props.titleIcon ? (
                                <div className={styles.infoWrap}>
                                    <span className={classNameIconType} style={styleTitleIcon} />
                                    <span className={styles.tooltipTitle}>{props.title}</span>
                                </div>
                            ) : (
                                <span className={styles.tooltipTitle}>{props.title}</span>
                            )}
                        </div>
                        <div className={classNameCategory}>{props.preTitle}</div>
                    </div>
                </div>
            </div>
            {appState.isAuthorizedUser && (
                <div className={classNameFooter}>
                    <Message type={typeMessage} style={null}>
                        {props.isEnabled ? t('Получено') : t('Не получено')}
                    </Message>
                </div>
            )}
            {props.content && <div className={classNames(styles.footerText, styles.lineHeight25, styles.top)}>{props.content}</div>}
            {props.description && <div className={classNames(styles.footerText, styles.top)}>{props.description}</div>}
            {props.isUniqueItem && <div className={classNames(styles.footerText, styles.unique, styles.top)}>{specialItemText}</div>}
            {props.isRareItem && <div className={classNames(styles.footerText, styles.gold, styles.top)}>{rareItemText}</div>}
            {renderAdditionalInfo()}
            {props.debugInfo && <div className={classNameFooter}>{props.debugInfo}</div>}
        </div>
    );
};

export default Tooltip;
